import React, { FC } from 'react';

import ContentArea from 'components/common/ContentArea';

import useStyles from './style';

const TimelinePlayBarPlaceholder: FC = () => {
  const classes = useStyles();

  return (
    <ContentArea className={classes.timelinePlayBarPlaceholder} shadowed>
      <span />
    </ContentArea>
  );
};

export default TimelinePlayBarPlaceholder;
